// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"f7e747ae","453":"ef56d468"}[chunkId] + ".chunk.js";
};